import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { createGame } from '../api/games';
import { saveSession } from '../api/session';
import { PageShell } from '../components/PageShell';
import { Form } from '../components/form/Form';

export default function CreatePage() {
  const nav = useNavigate();
  const [name, setName] = useState('');
  const [pin, setPin] = useState('');
  const [weaponMode, setWeaponMode] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleSubmit: React.FormEventHandler<HTMLFormElement> = async (e) => {
    e.preventDefault();
    setError(null);
    try {
      const game = await createGame(name, pin, weaponMode);
      saveSession({ code: game.join_code, playerName: name, token: game.token });
      nav(`/games/${game.join_code}/play`);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to create game');
    }
  };

  return (
    <PageShell>
      <Form
        title="Create Game"
        subtitle="The moderator manages the game, not a player. If you want to play; join as a player after creating the game."
        submitLabel="Create"
        disabled={!name || pin.length !== 4}
        onSubmit={handleSubmit}
      >
        <label className="label">
          Moderator username
          <input
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
            placeholder="username"
          />
        </label>
        <label className="label">
          Recovery PIN
          <input
            value={pin}
            onChange={(e) => setPin(e.target.value.replace(/\D/g, '').slice(0, 4))}
            placeholder="4 digits"
            inputMode="numeric"
            required
          />
        </label>
        <label
          className="label"
          title="Each player is secretly assigned a weapon they must use to eliminate their target"
        >
          Weapon mode
          <input
            type="checkbox"
            checked={weaponMode}
            onChange={(e) => setWeaponMode(e.target.checked)}
          />
        </label>
      </Form>
      {error && <p className="error">{error}</p>}
    </PageShell>
  );
}
